import React from "react";
import PropTypes from "prop-types";
import {
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import { AvField, AvForm } from "availity-reactstrap-validation";
import CustomSelect from "../../../../../components/Common/CustomSelect";

const PlanModal = ({
  isOpen,
  toggle,
  addPlan,
  offers,
  users,
  editData,
  updatePlanProfile,
  permissions,
  group_id,
  date,
}) => {
  const [selectedOffer, setSelectedOffer] = React.useState();
  const [selectedManager, setSelectedManager] = React.useState();
  const [isFormSubmit, setIsFormSubmit] = React.useState(false);

  React.useEffect(() => {
    if (editData !== null && isOpen) {
      let currentOffer = offers.findIndex(i => i.value === editData.offer);
      let currentManager = users.findIndex(
        i => i.value === editData.account_manager
      );
      setSelectedOffer(offers[currentOffer]);
      setSelectedManager(users[currentManager]);
    } else {
      setSelectedOffer("");
      setSelectedManager("");
      setIsFormSubmit(false);
    }
  }, [isOpen]);

  const onSubmit = (e, errors, params) => {
    setIsFormSubmit(true);

    if (errors?.length === 0) {
      let data = {
        ...params,
        offer: params.offer.value,
        account_manager: params.account_manager.value,
        group: group_id,
      };

      if (editData !== null) {
        updatePlanProfile(editData.id, data);
        toggle();
      } else {
        data["date_from"] = date.start_date;
        data["date_to"] = date.end_date;
        addPlan(data);
        toggle();
      }
    }
  };

  return (
    <Modal isOpen={isOpen} autoFocus={true} centered={true} toggle={toggle}>
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          {editData !== null ? "Edit" : "Add"} plan
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={onSubmit}>
        <ModalBody>
          <Row>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="validationCustom02">Project manager</Label>
                <CustomSelect
                  name="account_manager"
                  options={users}
                  placeholder="Select manager..."
                  defaultValue={selectedManager || ""}
                  onChange={setSelectedManager}
                  classNamePrefix="select2-selection"
                  errorMessage="Project manager field is required!"
                  required
                  isFormSubmit={isFormSubmit}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="validationCustom02">Offer: </Label>
                <CustomSelect
                  name="offer"
                  options={offers}
                  placeholder="Select offer..."
                  defaultValue={selectedOffer || ""}
                  onChange={setSelectedOffer}
                  classNamePrefix="select2-selection"
                  errorMessage="Offer field is required!"
                  required
                  isFormSubmit={isFormSubmit}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <div className="mb-3">
                <Label>Plan</Label>
                <AvField
                  name="plan"
                  type="number"
                  errorMessage="This value is required."
                  placeholder="Planned sum..."
                  value={editData?.plan || ""}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "This value is required",
                    },
                    min: {
                      value: 0,
                      errorMessage: "This value cannot be negative",
                    },
                  }}
                />
              </div>
            </Col>
            <Col className="col-12">
              <div className="mb-3">
                <Label>Corrected plan:</Label>
                <AvField
                  name="corrected_plan"
                  type="number"
                  errorMessage="This value is required."
                  placeholder="Corrected plan..."
                  value={editData?.corrected_plan || ""}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "This value is required",
                    },
                  }}
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {permissions?.["change_managerplanmodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

PlanModal.propTypes = {
  editData: PropTypes.any,
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  addPlan: PropTypes.func.isRequired,
  offers: PropTypes.arrayOf(PropTypes.object).isRequired,
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
  permissions: PropTypes.object.isRequired,
  updatePlanProfile: PropTypes.func.isRequired,
  group_id: PropTypes.any.isRequired,
  date: PropTypes.object,
};

export default PlanModal;
